<template>
	<div class="lida">
		<router-view />
		<div style="z-index: 999999" class="loadingBox" v-if="loading">
			<div v-loading="loading" element-loading-text="拼命加载中" class="loadingc"/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				//loading: false,
			}
		},
		computed:{
			loading(){
				return !!this.$store.state.reqNumber;
			},
		},
	}
</script>

<style scoped lang="less">
	.loadingBox {
		padding: 0;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 10000;
		box-sizing: border-box;
		.loadingc {
			height: 100%;
			width: 100%;
			.el-loading-spinner {
				top: 32% !important;
			}
			/deep/ .el-loading-mask{
				background-color: rgba(255, 255, 255, 0.5) !important;
			}
		}
	}
</style>
